// Personenzahl-Badge (Team-Anforderungen): signalisiert "Anzahl Personen", analog zur
// Schloss-Metapher in lock-icons.tsx. Kein Design-System-Primitive (@adr SPARK-0014-design-primitives-single-source@1) — ein
// domain-lokales Icon wie die Lock-Icons, kein anderes Person-Icon existiert im Repo.

export function PersonIcon() {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2.2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <circle cx="12" cy="8" r="3.5" />
      <path d="M5 20c0-3.5 3-6 7-6s7 2.5 7 6" />
    </svg>
  );
}
